import axiosInstance from "./AxiosInstance";

export function setSelectColumn(column, type = "") {
  let putData = { fields: column };
  if (type === "admin") {
    return axiosInstance.put("admin/candidate/search-keys", putData);
  } else {
    return axiosInstance.put("editor/candidates/update/searchkeys", putData);
  }
}

export function getSelectedColumn(type = "") {
  if (type === "admin") {
    return axiosInstance.get("admin/candidate/search-keys");
  } else {
    return axiosInstance.get("editor/candidates/fetch/searchkeys");
  }
}

export function sendJobs(data) {
  return axiosInstance.post("admin/candidate/send-job-emails", data);
}

export function download(data) {
  return axiosInstance.post("admin/user/check-quota", data);
}
